import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import Layout from '@meepshop/meep-ui/lib/layout';

var Container = function Container(_ref) {
  var userAgent = _ref.userAgent,
      page = _ref.page,
      product = _ref.product,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      globalCarousel = _ref.globalCarousel,
      globalPopup = _ref.globalPopup;
  return /*#__PURE__*/React.createElement(Layout, _extends({
    product: product,
    radiumConfig: {
      userAgent: userAgent
    } // for radium media query
    ,
    globalCarousel: globalCarousel,
    globalPopup: globalPopup
  }, page), children);
};

Container.propTypes = {
  page: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  userAgent: PropTypes.string.isRequired,
  children: PropTypes.element
};
export default Container;